module.exports = __webpack_public_path__ + "img/img_mainland_account_open_11.ae6a46b4.png";